module.exports = __webpack_public_path__ + "static/media/BrandonGrotesque-Medium.caff868c.otf";